/* Trashbags colorway vote — Shopify frontend.
 * The Cloudflare API is the source of truth for rules, deadlines and vote integrity.
 * Browser-side "already voted" memory is UX only; the server enforces everything. */
(function () {
  "use strict";
  var root = document.getElementById("tbv");
  if (!root) return;
  var API = (root.getAttribute("data-api") || "").replace(/\/+$/, "");
  var SITEKEY = root.getAttribute("data-sitekey") || "";
  // The sticky vote bar is moved to <body> ("dock") so no theme wrapper, transform or stacking context
  // can hide it or pin it to the section instead of the viewport, in any browser or window size.
  var dock = null;
  var el = function (name) {
    var s = '[data-tbv="' + name + '"]';
    return root.querySelector(s) || (dock && dock.querySelector(s));
  };
  (function mountDock() {
    var bar = root.querySelector('[data-tbv="bar"]');
    if (!bar || !document.body) return;
    dock = document.createElement("div");
    dock.className = "tbv tbv-dock"; dock.hidden = true;
    dock.appendChild(bar); document.body.appendChild(dock);
  })();
  var cfg = null, selected = [], clockOffset = 0, timer = null, busy = false;
  var me = null, postTab = null, boardTimer = null, boardRound = null; // post-vote state (server-confirmed only)
  var tsWidget = null, tsToken = null, tsWaiters = [], tsLoading = false;

  // ---------- small storage helpers (localStorage + first-party cookie fallback) ----------
  function getCookie(k) { var m = document.cookie.match(new RegExp("(?:^|; )" + k + "=([^;]*)")); return m ? decodeURIComponent(m[1]) : null; }
  function setCookie(k, v) { try { document.cookie = k + "=" + encodeURIComponent(v) + "; Max-Age=31536000; Path=/; SameSite=Lax; Secure"; } catch (e) {} }
  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} setCookie(k, v); }
  function recall(k) { var v = null; try { v = localStorage.getItem(k); } catch (e) {} return v || getCookie(k); }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16); crypto.getRandomValues(b); b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join("");
    return h.slice(0, 8) + "-" + h.slice(8, 12) + "-" + h.slice(12, 16) + "-" + h.slice(16, 20) + "-" + h.slice(20);
  }
  function storedDeviceId() { var id = recall("tbv_device"); return id && /^[0-9a-f-]{36}$/i.test(id) ? id : null; }
  function deviceId() {
    var id = recall("tbv_device");
    if (!id || !/^[0-9a-f-]{36}$/i.test(id)) id = uuid();
    store("tbv_device", id); // refresh both copies
    return id;
  }

  // ---------- rendering ----------
  function show(name, on) { var n = el(name); if (n) n.hidden = !on; if (name === "vote" && dock) dock.hidden = !on; }
  function text(name, t) { var n = el(name); if (n) n.textContent = t == null ? "" : t; }
  function now() { return Date.now() + clockOffset; }

  function renderHeader() {
    text("kicker", cfg.kicker || cfg.label || "COMMUNITY VOTE");
    text("copy", cfg.copy);
    text("select-label", cfg.select_label);
    text("max", cfg.max_picks);
    var flow = cfg.flow || "";
    if (cfg.round === "round1" && cfg.eligible && cfg.eligible.length) flow = flow.replace(/^\d+/, String(cfg.eligible.length));
    text("flow", flow);
    var steps = el("steps"); steps.innerHTML = "";
    (cfg.explainer || []).forEach(function (s, i) {
      var li = document.createElement("li");
      if ((cfg.round === "round1" && i === 0) || (cfg.round === "round2" && i === 1)) li.className = "is-now";
      var b = document.createElement("b"); b.textContent = s.title;
      var sp = document.createElement("span"); sp.textContent = s.body;
      var d = document.createElement("div"); d.appendChild(b); d.appendChild(sp); li.appendChild(d); steps.appendChild(li);
    });
    show("explainer", !!(cfg.explainer && cfg.explainer.length));
  }

  function status(title, body, opts) {
    opts = opts || {};
    show("loading", false); show("vote", false); show("post", false); stopBoard(); show("status", true);
    var em = el("email"), home = root.querySelector(".tbv-status .tbv-wrap"); if (em && home && em.parentNode !== home) home.appendChild(em);
    text("status-title", title); text("status-body", body);
    var p = el("status-picks");
    if (opts.picks) { p.textContent = "Your picks: " + opts.picks; p.hidden = false; } else { p.hidden = true; }
    show("retry", !!opts.retry);
    show("email", !!opts.email);
    if (!opts.when) { show("status-when", false); show("status-count", false); }
  }

  // Pre-open: "ROUND 1 OPENS" + opening time in Mountain Time (DST-aware via Intl) + live countdown.
  function roundNum() { var m = /(\d+)$/.exec(cfg.round || ""); return m ? m[1] : ""; }
  function fmtMT(iso) {
    var d = new Date(iso);
    try {
      var s = new Intl.DateTimeFormat("en-US", { timeZone: "America/Denver", weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }).format(d);
      return s.toUpperCase().replace(/,(?=[^,]*$)/, " ·") + " MT";
    } catch (e) { return d.toLocaleString(); }
  }
  function renderPreOpen() {
    var n = roundNum();
    status((n ? "ROUND " + n : (cfg.label || "VOTING")) + " OPENS", (cfg.messages && cfg.messages.pre_open && cfg.messages.pre_open.body) || "", { when: true, email: true });
    text("status-when", fmtMT(cfg.opens_at)); show("status-when", true); show("status-count", true);
  }
  function panelCount(label) { var n = el("status-count"); if (n && !n.hidden) n.textContent = label; }

  function votedKey() { return "tbv_voted_" + cfg.round; }

  // ---------- post-vote experience (YOUR PICKS | ALL COLORWAYS | LEADERBOARD) ----------
  // Everything personal here comes from the server (/api/me or the vote response). Standings are
  // only ever fetched from /api/leaderboard, which refuses to return them before this browser has an
  // accepted ballot in the current round (or until the server closes the round).
  function api(path, body) {
    return fetch(API + "/api/" + path, { method: "POST", headers: { "content-type": "application/json" }, credentials: "omit", cache: "no-store", body: JSON.stringify(body || {}) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; }); });
  }
  function fetchMe() {
    var id = storedDeviceId();
    if (!id) return Promise.resolve({ voted: false, picks: [] });
    return api("me", { device_id: id }).then(function (r) { if (r.status !== 200) throw new Error("me " + r.status); return r.body; });
  }
  function byId(id) { for (var i = 0; i < cfg.colorways.length; i++) if (cfg.colorways[i].id === id) return cfg.colorways[i]; return null; }
  function isMine(id) { return !!(me && me.voted && me.picks.indexOf(id) >= 0); }
  function staticCard(c, i) {
    var picked = isMine(c.id);
    var d = document.createElement("div");
    d.className = "tbv-card tbv-card--static" + (picked ? " is-picked" : "");
    var fig = document.createElement("span"); fig.className = "tbv-card__img";
    var img = document.createElement("img");
    img.alt = c.name; img.width = 480; img.height = 600; img.decoding = "async"; img.loading = i < 4 ? "eager" : "lazy";
    img.sizes = "(min-width: 1100px) 25vw, (min-width: 750px) 31vw, 47vw"; img.srcset = c.srcset; img.src = c.image;
    fig.appendChild(img); d.appendChild(fig);
    var name = document.createElement("span"); name.className = "tbv-card__name"; name.textContent = c.name; d.appendChild(name);
    if (picked) {
      var chk = document.createElement("span"); chk.className = "tbv-card__check"; chk.setAttribute("aria-hidden", "true"); chk.textContent = "✓"; d.appendChild(chk);
      var tag = document.createElement("span"); tag.className = "tbv-tag tbv-tag--pick"; tag.textContent = "✓ Your pick"; d.appendChild(tag);
    }
    return d;
  }
  function renderPostGrids() {
    var mine = el("mygrid"), all = el("allgrid"); mine.innerHTML = ""; all.innerHTML = "";
    var picks = (me && me.voted ? me.picks : []).map(byId).filter(Boolean);
    picks.forEach(function (c, i) { mine.appendChild(staticCard(c, i)); });
    cfg.colorways.forEach(function (c, i) { all.appendChild(staticCard(c, i)); });
    text("all-note", cfg.colorways.length + " colorways in " + (cfg.label === "ROUND 1" ? "Round 1" : cfg.label === "TOP 8" ? "Round 2" : cfg.label) + (me && me.voted ? " · your vote is locked" : ""));
  }
  function roundTitle(r) { var m = /(\d+)$/.exec(r || ""); return m ? "Round " + m[1] : "This round"; }
  function setTab(tab, focus) {
    var tabs = root.querySelectorAll(".tbv-tab"), panels = root.querySelectorAll("[data-panel]");
    Array.prototype.forEach.call(tabs, function (t) { var on = t.getAttribute("data-tab") === tab; t.setAttribute("aria-selected", on ? "true" : "false"); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
    Array.prototype.forEach.call(panels, function (p) { p.hidden = p.getAttribute("data-panel") !== tab; });
    postTab = tab;
    if (tab === "board") loadBoard(); else stopBoard();
  }
  function enterPost(mode, tab) {
    // mode: "voted" (round open, server-confirmed ballot) | "final" (server closed the round) | "prev" (earlier round's final results while the next round is pre-open)
    show("loading", false); show("vote", false); show("status", mode === "prev"); show("post", true);
    var voted = !!(me && me.voted);
    boardRound = mode === "prev" ? prevRound() : cfg.round;
    text("post-eyebrow", mode === "prev" ? roundTitle(boardRound) + " · final" : roundTitle(cfg.round));
    if (mode === "voted") { text("post-title", "Vote locked in."); text("post-sub", "Your picks are in."); }
    else if (mode === "final") { text("post-title", (cfg.messages && cfg.messages.closed && cfg.messages.closed.title) || "Voting is closed."); text("post-sub", voted ? "Your picks are in. Final results below." : "Final results are in."); }
    else { text("post-title", roundTitle(boardRound) + " final results"); text("post-sub", ""); }
    root.querySelector('.tbv-tab[data-tab="picks"]').hidden = !voted || mode === "prev";
    root.querySelector('.tbv-tab[data-tab="all"]').hidden = mode === "prev";
    el("tabs").hidden = mode === "prev";
    text("tab-board", mode === "voted" ? "Leaderboard" : "Final results");
    var em = el("email"), slot = el("post-email"); if (em && slot && mode !== "prev") { slot.appendChild(em); em.hidden = false; }
    renderPostGrids();
    var want = tab || (mode === "voted" ? "picks" : "board");
    if (want === "picks" && !voted) want = "board";
    setTab(want);
  }
  function prevRound() { var m = /(\d+)$/.exec(cfg.round || ""); return m && Number(m[1]) > 1 ? "round" + (Number(m[1]) - 1) : null; }

  // ---------- leaderboard ----------
  function stopBoard() { if (boardTimer) { clearInterval(boardTimer); boardTimer = null; } }
  function boardState(message, retry) {
    var st = el("board-state"); st.hidden = !message; text("board-msg", message || ""); el("board-retry").hidden = !retry;
  }
  function loadBoard() {
    stopBoard();
    var list = el("board");
    if (!list.children.length) boardState("Loading standings…", false);
    var body = { round: boardRound }; var id = storedDeviceId(); if (id) body.device_id = id;
    api("leaderboard", body).then(function (r) {
      if (r.status === 200 && r.body && r.body.rows) { boardState(""); renderBoard(r.body); if (!r.body.final) boardTimer = setInterval(function () { if (!document.hidden && postTab === "board") refreshBoard(); }, 60000); return; }
      list.innerHTML = "";
      var code = r.body && r.body.code;
      if (code === "vote_first") boardState("Vote to unlock the live leaderboard.", false);
      else if (code === "not_open") boardState("Standings appear once voting opens.", false);
      else boardState("Couldn't load the standings. Your vote is safe.", true);
    }).catch(function () { boardState("Couldn't load the standings. Your vote is safe.", true); });
  }
  function refreshBoard() {
    var body = { round: boardRound }; var id = storedDeviceId(); if (id) body.device_id = id;
    api("leaderboard", body).then(function (r) {
      if (r.status === 200 && r.body && r.body.rows) { renderBoard(r.body); if (r.body.final) { stopBoard(); if (cfg.state === "open" && boardRound === cfg.round) init(); } }
    }).catch(function () {});
  }
  function fmtNum(n) { try { return Number(n).toLocaleString("en-US"); } catch (e) { return String(n); } }
  function renderBoard(d) {
    var list = el("board"); list.innerHTML = "";
    var rt = roundTitle(d.round);
    text("board-title", d.final ? "Final " + rt + " results" : "Live leaderboard");
    text("board-sub", d.final ? (d.tie_at_cutoff ? "Tie at the advancement line — see below." : "Top " + d.advance + " advance.") : "Standings update as votes come in.");
    text("board-meta", fmtNum(d.total_voters) + (d.total_voters === 1 ? " voter" : " voters") + " · Top " + d.advance + " advance");
    var tiesOpened = false, lineDone = false;
    d.rows.forEach(function (r, i) {
      if (!lineDone && r.status === "tie" && !tiesOpened) { list.appendChild(line("Tie at the advancement line", "tie")); tiesOpened = true; }
      if (!lineDone && r.status === "out") { if (!tiesOpened) list.appendChild(line("Top " + d.advance + " advance", "cut")); else list.appendChild(line("", "end")); lineDone = true; }
      var li = document.createElement("li");
      li.className = "tbv-row is-" + r.status + (isMine(r.id) && d.round === cfg.round ? " is-mine" : "");
      var rank = document.createElement("span"); rank.className = "tbv-row__rank"; rank.textContent = "#" + r.rank; li.appendChild(rank);
      var fig = document.createElement("span"); fig.className = "tbv-row__img";
      var img = document.createElement("img"); img.alt = r.name; img.width = 480; img.height = 600; img.decoding = "async"; img.loading = i < 6 ? "eager" : "lazy";
      img.sizes = "(min-width: 750px) 140px, 96px"; if (r.srcset) img.srcset = r.srcset; if (r.image) img.src = r.image;
      fig.appendChild(img); li.appendChild(fig);
      var bodyEl = document.createElement("span"); bodyEl.className = "tbv-row__body";
      var nm = document.createElement("b"); nm.className = "tbv-row__name"; nm.textContent = r.name; bodyEl.appendChild(nm);
      var bar = document.createElement("span"); bar.className = "tbv-row__bar"; bar.setAttribute("aria-hidden", "true");
      var fill = document.createElement("i"); fill.style.width = Math.max(0, Math.min(100, r.percent)) + "%"; bar.appendChild(fill); bodyEl.appendChild(bar);
      var stats = document.createElement("span"); stats.className = "tbv-row__stats";
      stats.textContent = fmtNum(r.votes) + (r.votes === 1 ? " vote" : " votes") + " · " + r.percent + "% of voters"; bodyEl.appendChild(stats);
      var tags = document.createElement("span"); tags.className = "tbv-row__tags";
      if (isMine(r.id) && d.round === cfg.round) tags.appendChild(tagEl("✓ Your pick", "pick"));
      if (r.status === "tie") tags.appendChild(tagEl("Tied at the line", "tie"));
      if (d.final && r.status === "in") tags.appendChild(tagEl("Advances", "adv"));
      if (tags.children.length) bodyEl.appendChild(tags);
      li.appendChild(bodyEl); list.appendChild(li);
    });
    if (tiesOpened && !lineDone) list.appendChild(line("", "end"));
  }
  function line(label, kind) { var li = document.createElement("li"); li.className = "tbv-line tbv-line--" + kind; li.setAttribute("role", "separator"); if (label) { var s = document.createElement("span"); s.textContent = label; li.appendChild(s); } return li; }
  function tagEl(t, kind) { var s = document.createElement("span"); s.className = "tbv-tag tbv-tag--" + kind; s.textContent = t; return s; }

  function renderGrid() {
    var g = el("grid"); g.innerHTML = "";
    cfg.colorways.forEach(function (c, i) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "tbv-card"; b.setAttribute("aria-pressed", "false"); b.dataset.id = c.id;
      var fig = document.createElement("span"); fig.className = "tbv-card__img";
      var img = document.createElement("img");
      img.alt = c.name; img.width = 480; img.height = 600; img.decoding = "async";
      img.loading = i < 4 ? "eager" : "lazy"; if (i < 2) img.setAttribute("fetchpriority", "high");
      img.sizes = "(min-width: 1100px) 280px, (min-width: 750px) 31vw, 47vw";
      img.srcset = c.srcset; img.src = c.image;
      fig.appendChild(img);
      var name = document.createElement("span"); name.className = "tbv-card__name"; name.textContent = c.name;
      var chk = document.createElement("span"); chk.className = "tbv-card__check"; chk.setAttribute("aria-hidden", "true"); chk.textContent = "✓";
      b.appendChild(fig); b.appendChild(name); b.appendChild(chk);
      b.addEventListener("click", function () { toggle(b, c.id); });
      g.appendChild(b);
    });
    selected = []; updateBar();
  }

  function toggle(btn, id) {
    if (busy) return;
    var i = selected.indexOf(id);
    if (i >= 0) { selected.splice(i, 1); btn.setAttribute("aria-pressed", "false"); hint(""); }
    else {
      if (selected.length >= cfg.max_picks) {
        hint("MAX " + cfg.max_picks + " — TAP A PICK TO REMOVE IT");
        btn.classList.remove("is-full"); void btn.offsetWidth; btn.classList.add("is-full");
        return;
      }
      selected.push(id); btn.setAttribute("aria-pressed", "true"); hint("");
      loadTurnstile(); // start the (usually invisible) human check early so submit is instant
    }
    updateBar();
  }
  function hint(t) { text("hint", t); }
  function msg(t) { text("msg", t); }
  function updateBar() {
    text("count", selected.length);
    var s = el("submit");
    s.disabled = busy || selected.length < cfg.min_picks || selected.length > cfg.max_picks;
  }

  function tick() {
    if (!cfg) return;
    var target = cfg.state === "pre_open" ? Date.parse(cfg.opens_at) : Date.parse(cfg.deadline);
    if (!isFinite(target) || cfg.state === "closed") { text("countdown", ""); return; }
    var d = target - now();
    if (d <= 0) { text("countdown", cfg.state === "pre_open" ? "OPENING…" : "VOTING CLOSED"); clearInterval(timer); timer = null; setTimeout(init, 1500); return; }
    var days = Math.floor(d / 864e5), h = Math.floor(d % 864e5 / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
    var label = (cfg.state === "pre_open" ? "OPENS IN " : "ENDS IN ") + (days ? days + "D " : "") + h + "H " + m + "M " + s + "S";
    text("countdown", label);
    if (cfg.state === "pre_open") panelCount(label);
  }

  // ---------- Turnstile (loaded lazily; token verified server-side) ----------
  function loadTurnstile() {
    if (tsWidget !== null || tsLoading || !SITEKEY) return;
    tsLoading = true;
    window.tbvTurnstileReady = function () {
      try {
        tsWidget = window.turnstile.render(el("turnstile"), {
          sitekey: SITEKEY, action: "vote", appearance: "interaction-only", theme: "light", size: "flexible",
          "refresh-expired": "auto", "retry": "auto",
          callback: function (t) { tsToken = t; var w = tsWaiters; tsWaiters = []; w.forEach(function (f) { f(t); }); },
          "expired-callback": function () { tsToken = null; },
          "error-callback": function () { tsToken = null; msg("The human check couldn't load. Check your connection, then tap submit to retry."); return true; }
        });
      } catch (e) { msg("The human check couldn't load. Refresh the page and try again."); }
    };
    if (window.turnstile && window.turnstile.render) { window.tbvTurnstileReady(); return; }
    var s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=tbvTurnstileReady";
    s.async = true; s.defer = true;
    s.onerror = function () { tsLoading = false; msg("The human check couldn't load. Check your connection and try again."); };
    document.head.appendChild(s);
  }
  function getToken() {
    if (tsToken) return Promise.resolve(tsToken);
    loadTurnstile();
    return new Promise(function (resolve, reject) {
      var done = false;
      tsWaiters.push(function (t) { if (!done) { done = true; resolve(t); } });
      setTimeout(function () { if (!done) { done = true; reject(new Error("timeout")); } }, 30000);
    });
  }
  function resetTurnstile() { tsToken = null; try { if (tsWidget !== null) window.turnstile.reset(tsWidget); } catch (e) {} }

  // ---------- submit ----------
  function submit() {
    if (busy || selected.length < cfg.min_picks || selected.length > cfg.max_picks) return;
    busy = true; updateBar(); msg("");
    var btn = el("submit"); btn.textContent = "Checking…";
    getToken().then(function (token) {
      btn.textContent = "Submitting…";
      return fetch(API + "/api/vote", {
        method: "POST", headers: { "content-type": "application/json" }, credentials: "omit",
        body: JSON.stringify({ round: cfg.round, picks: selected.slice(), device_id: deviceId(), turnstile_token: token })
      }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; }); });
    }).then(function (res) {
      resetTurnstile();
      if (res.status === 200 && res.body && res.body.ok && Array.isArray(res.body.picks)) {
        // Picks shown from here on are the ones the SERVER accepted, not the on-screen selection.
        me = { voted: true, picks: res.body.picks.slice() };
        store(votedKey(), "1");
        enterPost("voted", "picks"); scrollToPost();
        return;
      }
      var code = res.body && res.body.code;
      if (res.status === 409 && code === "already_voted") { restoreFromServer(); return; }
      if (res.status === 403 && (code === "closed" || code === "pre_open" || code === "wrong_round")) { init(); return; }
      msg((res.body && res.body.error) || "Something went wrong. Tap submit to try again.");
    }).catch(function (e) {
      resetTurnstile();
      msg(e && e.message === "timeout" ? "The human check is taking too long. Tap submit to try again." : "Connection problem — your vote wasn't confirmed. Tap submit to try again.");
    }).then(function () {
      busy = false; btn.textContent = "Submit my picks"; updateBar();
    });
  }

  // ---------- email signup (optional, never required to vote) ----------
  el("email").addEventListener("submit", function (e) {
    e.preventDefault();
    var input = root.querySelector("#tbv-email-input"), out = el("email-msg"), b = e.target.querySelector("button");
    var email = (input.value || "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { out.textContent = "Enter a valid email."; return; }
    b.disabled = true; out.textContent = "";
    fetch(API + "/api/signup", { method: "POST", headers: { "content-type": "application/json" }, credentials: "omit", body: JSON.stringify({ email: email }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { out.textContent = r.ok ? "YOU'RE IN." : (j.error || "Try again."); if (r.ok) input.value = ""; }); })
      .catch(function () { out.textContent = "Connection problem. Try again."; })
      .then(function () { b.disabled = false; });
  });
  el("submit").addEventListener("click", submit);
  Array.prototype.forEach.call(root.querySelectorAll(".tbv-tab"), function (t) {
    t.addEventListener("click", function () { setTab(t.getAttribute("data-tab")); });
    t.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      var vis = Array.prototype.filter.call(root.querySelectorAll(".tbv-tab"), function (x) { return !x.hidden; });
      var i = vis.indexOf(t) + (e.key === "ArrowRight" ? 1 : -1); var n = vis[(i + vis.length) % vis.length];
      e.preventDefault(); setTab(n.getAttribute("data-tab"), true);
    });
  });
  el("board-retry").addEventListener("click", loadBoard);
  function scrollToPost() { var p = el("post"); if (p) window.scrollTo({ top: Math.max(0, p.getBoundingClientRect().top + window.pageYOffset - 90), behavior: "smooth" }); }
  function restoreFromServer() {
    fetchMe().then(function (m) {
      me = m;
      if (m.voted) { enterPost("voted", "picks"); scrollToPost(); }
      else status("Your vote is in.", "This device already voted in " + (cfg.label || "this round") + ".", { email: true });
    }).catch(function () { status("Your vote is in.", "This device already voted in " + (cfg.label || "this round") + ".", { email: true }); });
  }
  el("retry").addEventListener("click", function () { status("Loading…", ""); init(); });

  // ---------- boot ----------
  function init() {
    if (timer) { clearInterval(timer); timer = null; }
    if (!API) { status("Voting isn't set up yet.", "Check back soon.", {}); return; }
    fetch(API + "/api/config", { cache: "no-store", credentials: "omit" })
      .then(function (r) { if (!r.ok) throw new Error("config " + r.status); return r.json(); })
      .then(function (c) {
        cfg = c;
        var st = Date.parse(c.server_time); clockOffset = isFinite(st) ? st - Date.now() : 0; // countdown uses server time, not the phone clock
        renderHeader();
        show("loading", false);
        tick(); timer = setInterval(tick, 1000);
        if (c.state === "pre_open") { renderPreOpen(); if (prevRound()) enterPost("prev"); return; }
        if (!c.colorways || !c.colorways.length) { status("Voting is temporarily unavailable.", "Please try again shortly.", { retry: true }); return; }
        // Returning visitor? Ask the server whether THIS browser has a ballot in the CURRENT round.
        return fetchMe().catch(function () { return null; }).then(function (m) {
          me = m && m.round === c.round ? m : null;
          if (c.state !== "open") { enterPost("final"); return; }
          if (me && me.voted) { enterPost("voted", /^#leaderboard$/i.test(location.hash) ? "board" : "picks"); return; }
          if (!SITEKEY) { status("Voting is temporarily unavailable.", "Please try again shortly.", { retry: true }); return; }
          show("status", false); show("post", false); show("vote", true); renderGrid();
        });
      })
      .catch(function () { show("loading", false); status("Voting is temporarily unavailable.", "Please try again shortly.", { retry: true }); });
  }
  init();
})();
